// referenssiOptions.js

export const REFERENSSI_TUOTTEET = [
  "Kuntoarvio",
  "Asuntokaupan tarkastus",
  "TDD",
  "Märkätilojen kosteuskartoitus",
  "Ikkunoiden kuntoarvio",
  "Julkisivujen ja parvekkeiden kuntotutkimus",
  "Betonirakenteiden kuntotutkimus",
  "Viemäreiden kuntotutkimus",
  "LVV",
  "Putkiston kuntotutkimus",
];

export const REFERENSSI_KOHTEET = [
  "Koulu",
  "Päiväkoti",
  "Rivitalo",
  "Kerrostalo",
  "Erillistalo",
  "Asuinrakennus",
  "Omakotitalo",
  "Toimitilarakennus",
  "Teollisuusrakennus",
  "Logistiikka-/varastorakennus",
];